import Constants from "./Constants";

const Rental = {

  isVinVehicle(vehicle) {
    return Constants.VIN_CATEGORIES.some(category => category.value === vehicle.category.toUpperCase())
  }

};

export default Rental;
